module.exports = __webpack_public_path__ + "./imgs/biz_content_01_bg.png?3ef0485f5999dcbf2922507024d4622e";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/biz_content_01_bg.png
// module id = 8
// module chunks = 0 1 2 3 4 5 6